import React from "react";
import SettingsCard from "../common/settings-card";
import DefaultPrepTimes from "./default-prep-times";
import CustomPrepTimes from "./custom-prep-times";
import SettingsToggle from "../common/settings-toggle";
import { useSettingsData } from "../../../../contexts/SettingsDataContext";
import { LaptopMinimal } from "lucide-react-native";

const PrepTimeSettings: React.FC = () => {
  const { settings, handleDynamicPrepTime, isTestCallActive } =
    useSettingsData();

  const showDynamicToggle =
    settings.posProvider === "toast" ||
    (settings.posProvider === "stream" &&
      settings.orderingConfig?.dynamicPrepTime !== undefined);
  const dynamicEnabled =
    settings.orderingConfig?.dynamicPrepTime !== undefined
      ? settings.orderingConfig?.dynamicPrepTime
      : false;
  return (
    <SettingsCard title="Prep time">
      {showDynamicToggle && (
        <SettingsToggle
          title="Use POS prep time"
          description="Apply live prep time from Toast."
          value={dynamicEnabled}
          onValueChange={handleDynamicPrepTime}
          icon={LaptopMinimal}
          disabled={isTestCallActive}
        />
      )}
      <DefaultPrepTimes />
      <CustomPrepTimes />
    </SettingsCard>
  );
};

export default PrepTimeSettings;
